/************
 * Developed by : Shiva Software Solutions
 * Date : 15-05-2024
 * Descriptions : IPD reducers
 ************/
import {
  IPD_ADD_MEDICINE,
  APPROVE_IPDMEDICINE_MSG,
  IPD_DEPT_DET,
  IPD_PRES_CAT,
  IPD_PRES_OPTIONS,
  IPD_TXTEDITOR_URL
} from '../../shared/constants/ActionTypes';

const initialState = {
  ipdAddMedicine: null,
  approveIPDMed: null,
  ipdDeptDetails: '',
  ipdPresCat:'1',
  ipdTxtEditorUrl:'',
  ipd_pres_options:3
};

const ipdReducer = (state = initialState, action) => {
  switch (action.type) {
    case IPD_ADD_MEDICINE:
      return {
        ...state,
        ipdAddMedicine: action.payload,
      };
      case IPD_PRES_OPTIONS:
      return {
        ...state,
        ipd_pres_options: action.payload,
      };
      case IPD_TXTEDITOR_URL:
        return {
          ...state,
          ipdTxtEditorUrl: action.payload,
        };
      case IPD_PRES_CAT:
        return {
          ...state,
          ipdPresCat: action.payload,
        };
    case APPROVE_IPDMEDICINE_MSG:
      return {
        ...state,
        approveIPDMed: action.payload,
      };
    case IPD_DEPT_DET:
      return {
        ...state,
        ipdDeptDetails: action.payload,
      };
    default:
      return state;
  }
};

export default ipdReducer;
